import React from "react";
import AttractionsCarousel from "../AttractionsCarousel";
import wgb from "../images/banners/wgb.jpg";
import image1 from "../images/banners/shandon.png";

import "./Home.css";

export const LocalAttractions = () => {
  const attractions = [
    {
      title: "Glucksman Gallery, UCC",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vel magna vestibulum, blandit felis eget, eleifend ante. Phasellus pharetra faucibus tristique. Suspendisse potenti. Aenean posuere, tellus eu eleifend rhoncus, metus velit varius est, vitae rutrum leo urna a orci. Vestibulum elementum dictum mi. Aliquam quis ultricies metus, vitae mollis sapien. Fusce mollis nisl ut tempus efficitur. In hac habitasse platea dictumst. Vestibulum quis quam sed arcu pharetra convallis nec non elit. Aliquam orci lorem, scelerisque ac rutrum at, pharetra at ex. Cras gravida sem laoreet eros vehicula vestibulum. Maecenas at massa malesuada, commodo ipsum at, egestas elit. Phasellus varius molestie tellus, sed consectetur mauris tempor et. Nullam purus justo, tempus nec facilisis vestibulum, venenatis nec urna. Quisque laoreet ligula et lectus iaculis, in ultricies eros mattis. Ut viverra lacinia ante, mollis ultricies quam auctor et.",
      img: wgb,
      map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.1465966993396!2d-8.492990522806572!3d51.89478877190388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x484490235bae056f%3A0x6c30073eda1df7b!2sLewis%20Glucksman%20Gallery%2C%20University%20College%2C%20Cork!5e0!3m2!1sen!2sie!4v1741187896480!5m2!1sen!2sie",
    },
    {
      title: "Main Quad, UCC",
      description: "Modern art gallery on University College Cork campus",
      img: image1,
      map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.1988704817118!2d-8.494889722806649!3d51.893834771903805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4844902380bbc323%3A0x4d8a4bf0835e5291!2sUniversity%20College%20Cork!5e0!3m2!1sen!2sie!4v1741188004912!5m2!1sen!2sie",
    },
  ];

  return (
    <div className="attractions-page-layout">
      <div className="attractions-text-layout">
        <AttractionsCarousel prop={attractions} />
      </div>
    </div>
  );
};
